export default __webpack_public_path__ + "assets/images/b980661c8752a8bc0e156dcf15831e87.svg";